import { apiGet } from "@redriver/cinnamon";

const NAMESPACE = "SYSTEM/SHARING";
const ActionTypes = {
  GetSharingInfo: `${NAMESPACE}/GET_SHARING_INFO`,
};

export const getSharingInfo = (token) =>
  apiGet(ActionTypes.GetSharingInfo, `share/${token}`, null, { auth: false });
